import styled from "styled-components"

export const Button=styled.button`
background-color:black;
color:white;
width:100px;
height:50px;
`